import { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

export default (pathname) => {
  const documentURL = '/documents/';
  // eslint-disable-next-line react/destructuring-assignment
  if (pathname.includes(documentURL)) {
    return css`
      display: none;
      grid-column: 7/9;
      padding-left: 0;
      justify-self: baseline;

      @media ${breakpointsMinWidth.tabletMd} {
        display: flex;
        grid-column: 6/9;
      }
      @media ${breakpointsMinWidth.tabletLg} {
        grid-column: 6/9;
      }
    `;
  }

  return null;
};
